import type { User } from '../types';
import { getEndTimestamp } from './intermittentFasting';

export function isIntermittentFastingEnabled(user: Pick<User, 'intermittentFastingEnabled'> | null | undefined): boolean {
    return user?.intermittentFastingEnabled === true;
}

export { getSavedFastingGoalHours, saveFastingGoalHours } from './fastingPreferences';

export function getActiveFastEndTimestamp(
    startedAtIso: string,
    goalHours: number,
): number | null {
    const startedAt = new Date(startedAtIso).getTime();
    if (!Number.isFinite(startedAt)) return null;
    return getEndTimestamp({ startedAt, goalHours });
}
